/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ClasseSezioneForm } from './classe-sezione-form';


export interface ServizioMensaChiusuraScolasticaForm { 
    data_inizio: string;
    data_fine: string;
    classe?: string;
    sezione?: string;
    motivazione?: string;
    classi?: Array<ClasseSezioneForm>;
}

